import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import TopUpStatusMessage from './TopUpStatusMessage';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToApplyFlexiLoanForm: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/apply-flexi-loan/',
                search: '?topup=true'
            }
        })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

type Props = {
    accountId: string;
    className?: string;
} & PropsFromRedux;

const TopUpEligible = ({ goToApplyFlexiLoanForm, accountId }: Props) => {
    const handleRequestTopUp = () => {
        tracking.ampli.topupRequestStarted({
            account_id: accountId
        });

        goToApplyFlexiLoanForm();
    };

    return (
        <div className="flex flex-col items-center text-center">
            <TopUpStatusMessage
                heading={
                    <FormattedMessage
                        id="_.outstanding_view.topupEligibleTitle"
                        defaultMessage="Need more funds?"
                    />
                }
                description={
                    <FormattedMessage
                        id="_.outstanding_view.topupEligibleDescription"
                        defaultMessage="You can now request more funds - approval is subject to credit review"
                    />
                }
                trackEvent={() =>
                    tracking.ampli.topupRequestStarted({
                        account_id: accountId
                    })
                }
            />
            <Button
                data-testid="top-up-action-button"
                variant="primary"
                onClick={handleRequestTopUp}
                className="my-l"
            >
                <FormattedMessage
                    id="_.outstanding_view.createTopupRequest"
                    defaultMessage="Request more funds"
                />
            </Button>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(TopUpEligible);
